import { EnvironmentProviders } from '@angular/core';
import { provideHighcharts } from 'highcharts-angular';

export function provideXmlReport(): EnvironmentProviders {

    const providers = [
        provideHighcharts({
            modules: () => {
                return [
                    import('highcharts/esm/modules/accessibility'),
                    import('highcharts/esm/modules/offline-exporting'),
                    import('highcharts/esm/modules/exporting'),
                    import('highcharts/esm/highcharts-more'),
                    import('highcharts/esm/themes/sunset')
                ];
            },
            options: {
                colors: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'],
                exporting: {
                    sourceWidth: 1200,
                    sourceHeight: 500,
                    fallbackToExportServer: false,
                    buttons: {
                        contextButton: {
                            menuItems: [
                                'downloadPNG',
                                'downloadJPEG',
                                'downloadSVG'
                            ]
                        }
                    }
                }
            }
        })
    ];

    return providers as unknown as EnvironmentProviders;
}
